export default __webpack_public_path__ + "static/logo-3f1ee58aabf3f1ed338324468880f15c.png";